import React from 'react';
import {Warning} from "../../wui-core/src";
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import CheckboxButton from './CheckboxButton';
import { CheckboxGroupProps } from "./iCheckbox";

const {isShouldUpdate} = Warning;

const CheckboxGroupWrapper: React.FC<Partial<CheckboxGroupProps>> = (props) => {
    isShouldUpdate("CheckboxGroup", props);
    return <CheckboxGroup {...props} />;
};


type CheckboxType = typeof Checkbox & {
    Group: typeof CheckboxGroupWrapper;
    Button: typeof CheckboxButton;
};

const CheckboxWrapper = Checkbox as CheckboxType;
CheckboxWrapper.Group = CheckboxGroupWrapper;
CheckboxWrapper.Button = CheckboxButton;

export default CheckboxWrapper;
